import ProfilePic from "../../../../../../assets/images/users/1.jpg";
import CalendarIcon from "../../../../../../assets/images/calendar.svg";
import Avatar from 'components/Avatar/Avatar';
import styles from './Overview.module.scss';

export default function Overview() {
  const avartarItem = {
    "fullName": "Chad Giles",
    "userName": "Chad.Giles@gds.ey.com",
    "email": "Chad.Giles@gds.ey.com",
    "picture": ProfilePic,
    "role": "Risk Owner"
  }

  return (
    <div className="pv-3">
      <div className="d-flex align-items-center justify-content-between">
        <h5>Description</h5>

        <button className="btn btn-flat text-white flex-center">
          Show more
          <i className="icon-arrow-right text-5c ml-2"></i>
        </button>
      </div>
      <div className="mv-4">
        <p className={styles.description}>
          Supply chain risk refers to the potential disruptions or threats to the smooth functioning of a company's supply chain operations. It can come from various sources and may impact different stages of the supply chain, including procurement, manufacturing, transportation, and distribution.
          <br />
          <br />
          Supply chain risks can arise from natural disasters, such as earthquakes, floods, and hurricanes, which can disrupt transportation and cause delays or damage to goods. Political instability, such as civil unrest or trade sanctions, can also impact the supply chain by restricting or delaying the movement of goods across borders. Moreover, cyber-attacks and data breaches can compromise the integrity of the supply chain by disrupting digital systems and exposing sensitive information.
          <br />
          <br />
          Another common source of supply chain risk is the reliability and performance of suppliers. Supplier bankruptcy, quality issues, labor disputes, and shipping delays are examples of supplier-related risks that can cause disruptions to a company's supply chain. Additionally, demand variability, where the actual customer demand differs from the expected demand, can also lead to supply chain risk, resulting in stockouts or overstocks.
          <br />
          <br />
          Supply chain risk can have significant financial and reputational implications for a company. It can result in increased costs due to delays, loss of revenue due to stockouts, and damage to the company's reputation due to failure to meet customer expectations. Therefore, it is crucial for companies to identify and manage supply chain risks proactively by developing and implementing risk management strategies and contingency plans to mitigate the potential impact of any disruptions.
        </p>
      </div>
      <div className="row mt-5">
        <div className="col-2 d-flex">
          <Avatar src={avartarItem.picture} alt={avartarItem.fullName} />
          <div className="ph-3">
            <span className={styles.userPaneTextName}>{avartarItem.fullName}</span>
            <span className={styles.userPaneTextRole}>{avartarItem.role}</span>
          </div>
        </div>
        <div className="col-2 d-flex">
          <Avatar src={CalendarIcon} alt="time period" />
          <div className="ph-3">
            <span className={styles.userPaneTextName}>Time Period</span>
            <span className={styles.userPaneTextRole}>Q4 FY24</span>
          </div>
        </div>
      </div>
    </div>
  );
}
